import { useMemo } from 'react'
import { brands as Brands } from '@/types/thermostatBrands'
import useMultiProgramFlowControl from '@/hooks/useMultiProgramFlowControl'
import useMultiProgramEligibleDeviceTypes from '@/hooks/useMultiProgramEligibleDeviceTypes/useMultiProgramEligibleDeviceTypes'
import { filterThermostatBrandsForMPFlow } from './filterThermostatBrandsForMPFlow'

function useViewModel() {
  const { inFlow, multiProgramFlowProgramId } = useMultiProgramFlowControl()
  const { deviceTypes, isLoadingOrIdle } = useMultiProgramEligibleDeviceTypes(
    multiProgramFlowProgramId,
  )

  const brands = useMemo(
    () =>
      filterThermostatBrandsForMPFlow(
        Brands,
        inFlow,
        deviceTypes,
        isLoadingOrIdle,
      ),
    [inFlow, deviceTypes, isLoadingOrIdle],
  )

  return {
    brands,
  }
}

export default useViewModel
